module.exports = ""


//////////////////
// WEBPACK FOOTER
// ./src/app/shared/components/pagination/pagination.component.scss
// module id = ./src/app/shared/components/pagination/pagination.component.scss
// module chunks = main